import { getToken } from "../services/auth";
import PrintServices from "../services/cozinha";

export const useDeliveryPrintKitchen = () => {
    
    const printKitchen = async({reprint, id_movimento})=>{
        try{
            const service = new PrintServices()
            const result = await service.getObsKitchenPrint({
                cnpj:getToken('CNPJ'),
                id_movimento: parseInt(id_movimento),
                tipo:"D",
                reimpressao:reprint
    
            })
            
            return result;

        }catch(error){
            return {success: false, data: [], message: error};
        }
    }

    return {
        printKitchen
    }

}